import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoofDoor: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-roof-door, house"><path d="M4.75 8.5V20.25H19.25V8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.5 9.55119L12 2.75L21.5 9.55119" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.25 20V13.75H9.75V20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHomeRoofDoor;
